import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useBreakpoint from 'antd/es/grid/hooks/useBreakpoint';
import { Avatar, Button, Col, Divider, Dropdown, Row, theme, Typography } from 'antd';
import { UserOutlined, MoneyCollectOutlined, LogoutOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import accountDetailItems from '../../static/accountDetailItems';
import LanguageSwitcher from '../general/LanguageSwitcher';
import { useAppSelector } from '../../hooks/store';
import keycloak from '../../config/keycloak';

function ProfileMenu() {
    const screens = useBreakpoint();
    const { useToken } = theme;

    const loggedUser = useAppSelector((state) => state.global.loggedUser);

    const { token } = useToken();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const location = useLocation();

    const logoutButton = () => {
        return {
            key: 'logout',
            label: 'Logout',
            icon: <LogoutOutlined />,
            onClick: () => {
                keycloak.logout();
            },
        };
    };

    const dropdownItems = (accountDetailItems(t) ?? []).concat(logoutButton());

    const contentStyle: React.CSSProperties = {
        backgroundColor: token.colorBgElevated,
        borderRadius: token.borderRadiusLG,
        boxShadow: token.boxShadowSecondary,
    };

    const menuStyle: React.CSSProperties = { boxShadow: 'none' };

    const popupRender = (menu: React.ReactNode) => (
        <div style={contentStyle}>
            {React.cloneElement(
                menu as React.ReactElement<{
                    style: React.CSSProperties;
                }>,
                { style: menuStyle },
            )}
            <Divider style={{ margin: 0 }} />
            <Row align="middle" style={{ padding: 8 }}>
                <LanguageSwitcher width="100%" />
            </Row>
        </div>
    );

    const getUserName = () => {
        if (loggedUser) {
            return `${loggedUser.firstName} ${loggedUser.lastName}`;
        }

        return '';
    };

    const handleMenuClick = ({ key }: { key: string }) => {
        // navigate to the clicked menu item's key (which is a route path)
        navigate(key);
    };

    const getButtonContent = () => {
        if (!screens.md) {
            return <Avatar size={40} icon={<UserOutlined />} />;
        }
        return (
            <Row style={{ columnGap: 5 }} align="middle">
                <Avatar size={40} icon={<UserOutlined />} />
                <Col style={{ columnGap: 5 }}>
                    <Typography.Title level={4} style={{ margin: 0 }}>
                        {getUserName()}
                    </Typography.Title>
                    <Row
                        align="middle"
                        style={{
                            columnGap: 2,
                            color: 'yellow',
                            fontSize: 18,
                        }}
                    >
                        <MoneyCollectOutlined />
                        <Row align="top">
                            <Typography.Text style={{ color: 'yellow' }}>{999} BP</Typography.Text>
                        </Row>
                    </Row>
                </Col>
            </Row>
        );
    };

    const activeRoute = dropdownItems.find((item) => item?.key === location.pathname)?.key as string | undefined;
    return (
        <Dropdown
            menu={{ items: dropdownItems, onClick: handleMenuClick, activeKey: activeRoute ?? undefined }}
            arrow
            popupRender={popupRender}
            mouseLeaveDelay={0.25}
        >
            <Button style={{ height: 'auto', padding: '4px 10px' }} type="text">
                {getButtonContent()}
            </Button>
        </Dropdown>
    );
}
export default ProfileMenu;
